<template>
  <v-card>
    <v-toolbar flat color="white" density="compact">
      <v-tabs v-model="tab" slider-color="success">
        <v-tab color="primary">{{ $store.getters.translate("general_info").toUpperCase() }}</v-tab>
        <v-tab v-if="show_2nd_tab" color="primary">{{ $store.getters.translate("additional_information").toUpperCase() }}</v-tab>
      </v-tabs>
      <v-spacer/>
      <div class="chip-container">
        <base-action-button v-if="canDelete" :delete="true" @action="archive">
          <template #prepend><PhArchive style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("delete") }}
        </base-action-button>
        <base-action-button v-if="canEdit" @action="save">
          <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
          {{ $store.getters.translate("save") }}
        </base-action-button>
      </div>
    </v-toolbar>
    <v-window v-model="tab">
      <v-window-item>
        <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
          <base-field
              v-for="field in usual_fields"
              :isDisabled="!canEdit"
              :key="field.name"
              :modelValue="record[field.name]"
              :field="field"
              @change="usualFieldDataChanged"/>
          <base-field
              v-for="field in custom_fields"
              :isDisabled="!canEdit"
              :key="field.name"
              :modelValue="record.custom_fields[field.name]"
              :field="field"
              @change="customFieldDataChanged"/>
        </v-card>
      </v-window-item>
      <v-window-item v-if="show_2nd_tab">
        <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
          <slot name="additional_information"/>
        </v-card>
      </v-window-item>
    </v-window>
  </v-card>
</template>

<script>
import { useAbility } from '@casl/vue';
import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "./BaseActionButton";
import {PhArchive, PhEye, PhFloppyDisk} from "@phosphor-icons/vue";

export default {
  components: { BaseActionButton, PhFloppyDisk, PhEye, PhArchive },
  props: ["page", "record", "show_2nd_tab"],
  setup() {
    const { can } = useAbility()
    return { can }
  },
  data() {
    return {
      tab: 0,
      usual_fields: [],
      custom_fields: [],
    };
  },
  mounted() {
    this.getFields();
  },
  methods: {
    async save() {
      if (helpFunctions.modelFieldsFilled(this.$toast, this.record, this.usual_fields)) {
        if (await helpFunctions.saveModel(this.$toast, this.page.name, this.record)) {
          this.$emit('reload');
        }
      }
    },
    async archive() {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, this.record.id);
          await this.$router.push("/" + this.page.name);
        }
      });
    },
    usualFieldDataChanged(data) {
      if(this.record[data[0]] !== data[1]) {
        this.record[data[0]] = data[1];
      }
    },
    customFieldDataChanged(data) {
      this.record.custom_fields[data[0]] = data[1];
    },
    async getFields() {
      const response = await helpFunctions.getFields(this.page.model, "show_on_update");
      this.usual_fields = response.usual_fields;
      this.custom_fields = response.custom_fields;
    },
  },
  computed: {
    canEdit() {
      return this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: 0 })) ||
          this.can("edit", this.$createEntity(this.page.model.toLowerCase(), { id: this.record.id }));
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: 0 })) ||
          this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: this.record.id }));
    },
  },
};
</script>

<style scoped>
.chip-container {
  display: flex;
  gap: 8px;
  margin-right: 16px;
}
</style>